module.exports = __webpack_public_path__ + "static/media/perler-mario.51b72b04.jpg";